define('widgets',['event-manager', 'jquery', 'underscore', 'lib', 'lazy-loader',
    'jsx!components/min-e24-box/main',
    'jsx!components/finn-carousel/main',
    'jsx!components/finn-blink/main',
    'jsx!components/livestocks/login-or-redirect-button',
    'jsx!components/lists/content-marketing',
], function(eventManager, $, _, lib, LazyLoader,
    MinE24BoxComponent,
    FinnCarouselComponent,
    FinnBlinkComponent,
    loginOrRedirectButtonComponent,
    ContentMarketing
) {
    'use strict';

    /*jshint validthis: true */
    function lazyLoad(component, el, config, condition) {
        if (condition) {
            new LazyLoader({
                on: el,
                threshold: 800,
                callback: function(el){
                    component.apply(this, [el, config]);
                }
            });
        } else {
            component.apply(this, [el, config]);
        }
    }

    function renderWidgets() {
        _.each($('[data-widget]'), function(el) {
            if (!el.rendered) {
                el.rendered = true;
                var config = {};
                var lazy = !!el.getAttribute('data-lazy');
                switch(el.getAttribute('data-widget')) {
                    case 'min-e24-box':
                        lazyLoad(MinE24BoxComponent, el, config, lazy);
                        break;
                    case 'finn-carousel':
                        lazyLoad(FinnCarouselComponent, el, config, lazy);
                        break;
                    case 'finn-blink':
                        lazyLoad(FinnBlinkComponent, el, config, lazy);
                        break;
                    case 'livestocks-button':
                        lazyLoad(loginOrRedirectButtonComponent, el, config, lazy);
                        break;
                    case 'content-marketing':
                        lazyLoad(ContentMarketing, el, config, lazy);
                        break;
                }
            }
        });
    }

    eventManager.on('domready e24-widgets-render', renderWidgets);
});

